import { config } from "dotenv";

config();

const appName = process.env?.VUE_APP_APP_NAME ? process.env.VUE_APP_APP_NAME : "app";
export const LogGroupName = {
  frontError: `${appName}/frontError`,
};
